import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { EstadosOSE } from 'constants/index'

const EstadoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='input-estado' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='estado'>
          {({ field }) => (
            <Form.Select {...field} id='input-estado-comprobantesElectronicos' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>TODOS</option>
              {EstadosOSE.__array.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoFormGroup)
